import { ButtonModule } from 'primeng/button';
import { TranslatePipe } from '@/app/layout/pipes/translate.pipe';
import { UserService } from '@app/plateformebeneficiaire/core';
import { Router } from '@angular/router';
import { Component, computed, effect, inject, linkedSignal, signal } from '@angular/core';

@Component({
    standalone: true,
    templateUrl: './login-callback.component.html',
    imports: [ButtonModule]
})
export class LoginCallbackComponent {
  #userService = inject(UserService);
  #router = inject(Router);

  #userInfoQuery = this.#userService.getUserInfos();
  
  userInfos = computed(() => this.#userInfoQuery.data());
  isLoading = computed(() => this.#userInfoQuery.isLoading());
  hasError = linkedSignal(() => this.#userInfoQuery.isError());

  constructor() {
    effect(() => {
      if (!this.isLoading() && !this.hasError()) {
        this.#router.navigate(['/app']);
      }
    });
  }
}
